import { useRouter } from 'next/router';
import { ContentCompact, HeaderFunnel } from '@angeplus/prever-component-lib';
import { PetCremationHasBenefit } from './PetCremationHasBenefit';

export const PetCremation = () => {
  const router = useRouter();

  return (
    <ContentCompact>
      <HeaderFunnel onClickArrow={router.back}>Proteção Pet</HeaderFunnel>
      <PetCremationHasBenefit />
    </ContentCompact>
  );
};
